module.exports = __webpack_public_path__ + "static/img/242_TO8_2182.cfd78a0.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/242_TO8_2182.jpg
// module id = MMli
// module chunks = 0